import useAsbisUiConfig from "../composables/useAsbisUiConfig.mjs";
import {
  AbAnalyticEventEnum
} from "./types.mjs";
export default function useAnalytics() {
  const { analytics = {} } = useAsbisUiConfig();
  const trackEvent = (payload) => {
    if (analytics.debug) {
      console.log("[Asbis UI Analytics]", payload);
    }
    if (!analytics.enabled) {
      return;
    }
    analytics.handler?.(payload);
  };
  const trackViewSection = (section, placement, items) => {
    trackEvent({
      section,
      event: AbAnalyticEventEnum.ViewSection,
      data: { placement, items }
    });
  };
  const trackSelectItem = (section, placement, items) => {
    trackEvent({
      section,
      event: AbAnalyticEventEnum.SelectItem,
      data: { placement, items }
    });
  };
  const trackViewSectionCatalog = (section, placement, items) => {
    const currency = items[0]?.currency ?? "";
    trackEvent({
      section,
      event: AbAnalyticEventEnum.ViewSectionCatalog,
      data: { placement, currency, items }
    });
  };
  const trackSelectItemCatalog = (section, placement, items) => {
    const { currency = "", price = 0, discount = 0 } = items[0] || {};
    trackEvent({
      section,
      event: AbAnalyticEventEnum.SelectItemCatalog,
      data: {
        placement,
        currency,
        item_cost: price,
        total_discount: discount,
        items
      }
    });
  };
  const trackViewForm = (section, data) => {
    trackEvent({
      section,
      event: AbAnalyticEventEnum.ViewForm,
      data
    });
  };
  const trackStartForm = (section, data) => {
    trackEvent({
      section,
      event: AbAnalyticEventEnum.StartForm,
      data
    });
  };
  const trackSubmitForm = (section, data) => {
    trackEvent({
      section,
      event: AbAnalyticEventEnum.SubmitFormSuccess,
      data
    });
  };
  const trackSubmitFormSuccess = (section, data) => {
    trackEvent({
      section,
      event: AbAnalyticEventEnum.SubmitFormSuccess,
      data
    });
  };
  return {
    trackEvent,
    trackViewSection,
    trackSelectItem,
    trackViewSectionCatalog,
    trackSelectItemCatalog,
    trackViewForm,
    trackStartForm,
    trackSubmitForm,
    trackSubmitFormSuccess
  };
}
